'use client';

import { c as _c } from "react/compiler-runtime";
import { useAccess } from '@repo/auth';
import { getLoadCreationCapabilities, loadCreationAccessRequirements } from './load-creation-access.ts';
export const useLoadCreationAccess = () => {
  const $ = _c(4);
  const createNormalLoadAccess = useAccess(loadCreationAccessRequirements.createNormalLoad);
  const createDraftAccess = useAccess(loadCreationAccessRequirements.createDraft);
  const publishDraftAccess = useAccess(loadCreationAccessRequirements.publishDraft);
  let t0;
  if ($[0] !== createDraftAccess.allowed || $[1] !== createNormalLoadAccess.allowed || $[2] !== publishDraftAccess.allowed) {
    t0 = getLoadCreationCapabilities({
      canCreateDraft: createDraftAccess.allowed,
      canCreateNormalLoad: createNormalLoadAccess.allowed,
      canPublishDraft: publishDraftAccess.allowed
    });
    $[0] = createDraftAccess.allowed;
    $[1] = createNormalLoadAccess.allowed;
    $[2] = publishDraftAccess.allowed;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};